import { useI18n } from './useI18n';

// @ts-ignore
import commonPt from '@/data/locales/pt-BR/common.json';
// @ts-ignore
import commonEs from '@/data/locales/es/common.json';
// @ts-ignore
import commonEn from '@/data/locales/en/common.json';
// @ts-ignore
import commonDe from '@/data/locales/de/common.json';
// @ts-ignore
import commonFr from '@/data/locales/fr/common.json';

const translations: Record<string, Record<string, string>> = {
  'pt-BR': commonPt,
  es: commonEs,
  en: commonEn,
  de: commonDe,
  fr: commonFr,
};

export function useTranslation() {
  const { lang } = useI18n();
  const t = (key: string, values?: Record<string, string | number> | string): string => {
    let text = translations[lang]?.[key] || translations['pt-BR']?.[key];
    if (!text) {
      if (typeof values === 'string') return values;
      return key;
    }
    if (values && typeof values === 'object') {
      Object.entries(values).forEach(([k, v]) => {
        text = text.replace(new RegExp(`{{${k}}}`, 'g'), String(v));
      });
    }
    return text;
  };
  return { t, lang };
}
